
export default{
	//   time_value(numt){//常用日期转换
	// 	let num = Math.sign(numt) // 判断正负数
  	// 	if(num==0||numt==null||numt==''||num == -1){
  	// 		return  ''
  	// 	}
	// 	var date = new Date(numt);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    //     var Y = date.getFullYear() + '-';
    //     var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    //     var D = (date.getDate()+1 < 10 ? '0'+date.getDate() : date.getDate());
    //     var h = date.getHours() + ':';
    //     var m = date.getMinutes() + ':';
    //     var s = date.getSeconds();
    //     return Y+M+D;
	// },
	time_value(num, fmt = 'yyyy-MM-dd') { // yyyy-MM-dd
		if(!num) return num
		let date = new Date(num);
		var o = {
		  "M+": date.getMonth() + 1, //月份
		  "d+": date.getDate(), //日
		  "h+": date.getHours(), //小时
		  "m+": date.getMinutes(), //分
		  "s+": date.getSeconds(), //秒
		  "q+": Math.floor((date.getMonth() + 3) / 3), //季度
		  "S": date.getMilliseconds() //毫秒
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	},
	regExpFileIco(suffix){//判断文件类型
		if(suffix!=null){
			suffix=suffix.toLocaleLowerCase();
			var doc=new RegExp("(doc|docx)$");
			var img=new RegExp("(jpg|jpeg|gif|png|svg|bmp)$");
			var movie=new RegExp("(mp4|rmvb|avi|ts)$");
			var pdf=new RegExp("(pdf)$");
			var xls=new RegExp("(xls|xlsx)$");
			var dwg=new RegExp("(dwg|dxf|dwt)$");
			if(doc.test(suffix)){
				return 'doc'
			}else if(img.test(suffix)){
				return 'img'
			}else if(pdf.test(suffix)){
				return 'pdf'
			}else if(xls.test(suffix)){
				return 'xls'
			}else if(movie.test(suffix)){
        return 'movie'
      }else if(dwg.test(suffix)){
        return 'dwg'
      }else{
				return 'xxxx'
			}
		}else{
			return 'file'
		}
	},
	distinct(arrObj){//对象数组去重
		var arr = arrObj,
		  	result = [],
		  	i,
		  	j,
		  	len = arr.length;
		for(i = 0; i < len; i++){
			for(j = i + 1; j < len; j++){
			   	if(arr[i] === arr[j]){
			    	j = ++i;
			   	}
			}
			result.push(arr[i]);
		}
		return result;
	},
	dateThan(day1,day2,interval){//时间间隔返回

		if(typeof(arguments[0])!="number"){
			arguments[0]=Date.parse(arguments[0])
		}
		if(typeof(arguments[1])!="number"){
			arguments[1]=Date.parse(arguments[1])
		}

		if(arguments[1]-arguments[0]>0){
			return 'pastDue'
		}else{
			if(Math.abs(arguments[1]-arguments[0])<(interval*1000)){
				return 'hint'
			}
		}

	},
	formatMoney(money,places, symbol, thousand, decimal){//金钱格式化
		places = !isNaN(places = Math.abs(places)) ? places : 2;
        symbol = symbol !== undefined ? symbol : "¥";
        thousand = thousand || ",";
        decimal = decimal || ".";
        var number = money,
            negative = number < 0 ? "-" : "",
            i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
	},
	uniq(arr){//数组去重
		var res = [arr[0]];
		 for(var i=1; i<arr.length; i++){
		  var repeat = false;
		  for(var j=0; j<res.length; j++){
		   if(arr[i] === res[j]){
		    repeat = true;
		    break;
		   }
		  }
		  if(!repeat){
		   res.push(arr[i]);
		  }
		 }
		 return res;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/universaiMethod/utils.js